/* @flow */
// typecheck: ignore file
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import React from 'react';
import Subscriber from 'entities/Subscriber';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton.jsx';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  className?: string,
  groupMembership?: GroupMembership,
  subscriber?: Subscriber,
  groupToAdmin?: Group,
  onClick?: Function,
  level?: string,
  showViewProfile?: bool,
  tooltip?: string,
  tooltipPlacement?: string,
};

class GroupMembersTabUserActions extends React.Component {
  props: Props;

  showCopyToClass = () => {
    const { groupMembership, subscriber } = this.props;
    const sub = subscriber || (groupMembership && groupMembership.getSubscriber());

    return sub && sub.getCanBeCopiedToClass();
  };

  showMakeOwner = () => {
    const { groupMembership } = this.props;
    return groupMembership && groupMembership.getCanBecomeOwner();
  };

  showBlockMember = () => {
    const { groupMembership } = this.props;
    return !!groupMembership;
  };

  showRemoveFromSchool = () => {
    const { groupMembership } = this.props;
    const hasAdminConsole = CurrentUser.getUser().hasFeature('web_admin_console');
    if (this.isRootGroup()) {
      return false;
    } else if (hasAdminConsole) {
      return false;
    } else if (groupMembership && groupMembership.hasPermission('can_remove_from_org')) {
      return true;
    }
    return false;
  };

  isRootGroup = () => {
    const { groupToAdmin } = this.props;
    return groupToAdmin && groupToAdmin.isRoot();
  };

  render() {
    const { groupMembership, subscriber, groupToAdmin } = this.props;
    const sub = subscriber || (groupMembership && groupMembership.getSubscriber());
    const isRootGroup = this.isRootGroup();

    return (
      <UserActionsMenuButton
        className={this.props.className}
        buttonSize="small"
        onClick={this.props.onClick}
        level={this.props.level}
        tooltip={this.props.tooltip}
        tooltipPlacement={this.props.tooltipPlacement}
        subscriber={sub}
        groupMembership={groupMembership}
        groupToAdmin={groupToAdmin}
        showViewProfile={this.props.showViewProfile}
        showChangeRole={false}
        showCopyToClass={this.showCopyToClass()}
        showMakeOwner={!isRootGroup && this.showMakeOwner()}
        showRemoveMember={!isRootGroup && groupMembership && groupMembership.hasPermission('can_remove_from_group')}
        showBlockMember={this.showBlockMember()}
        showGetTranscript={groupMembership && groupMembership.hasPermission('can_admin')}
        showRemoveFromSchool={this.showRemoveFromSchool()}
        showReportAsUser={isRootGroup || (!groupMembership || !groupMembership.hasPermission('can_admin'))}
        showReportAsAdmin={!isRootGroup && groupMembership && groupMembership.hasPermission('can_admin')}
      />);
  }
}

export default GroupMembersTabUserActions;



// WEBPACK FOOTER //
// ./src/user/components/GroupMembersTabUserActions.jsx